import HubCtas from "../../views/hub/HubCtas.vue";
import HubMenu from "../../views/hub/HubMenu.vue";
import HubHeader from "../../views/hub/HubHeader.vue";

export default [
  {
    path: "/",
    name: "Hub",
    components: {
      sectionNavigation: HubMenu,
      header: HubHeader,
      content: HubCtas,
    },
  },
  {
    path: "/:volumeSlug/",
    name: "HubWithVolume",
    components: {
      sectionNavigation: HubMenu,
      header: HubHeader,
      content: HubCtas,
    },
  },
];
